import common from "../common";
import Button from "./Button";

export default class RadioButton extends Button {

    constructor(label, id, group, value, checked, css)
    {
        if(css == null) css = {};

        if(!css.height) css.height = '7' + common.cssUnit;

        super(css); //runs init

        this.backing = null;
        this.buttonText = null;

        this.addBacking();

        this.initRadio(label, id, group, value, checked);
    }

    addBacking()
    {
        this.htmlElement.addClass('p3-radioHolder');
    }

    initRadio(label, id, group, value, checked)
    {
        this.type = this.TYPE_RADIO;

        //this.htmlElement.css('minWidth', 'auto');
        //this.htmlElement.css('minHeight', 'auto');

        this.formElement = $("<input class='p3-radioButton' type='radio' id='" + id + "' name='" + group + "' value='" + value + "' " + (checked ? 'checked' : '') + ">");
        this.htmlElement.append(this.formElement);

        this.formElement.on('change', function(){
            this.signals.changed.dispatch();
        }.bind(this));

        this.formElementLabel = $("<label class='p3-radioLabel' for='" + id + "'>" + label + "</label>");
        this.htmlElement.append(this.formElementLabel);

        this.addListeners();
    }

    sizeForGEL()
    {
        
    }

    onFocusIn(e)
    {

    }

    onFocusOut(e)
    {

    }
}